import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
@Component({
  selector: 'app-addrestaurantprebooking',
  templateUrl: './addrestaurantprebooking.component.html'
})
export class AddrestaurantprebookingComponent implements OnInit {

//   constructor() { }

//   ngOnInit() {
//   }

// }




  @Output() emitData = new EventEmitter();
  
  @Input() prebookingid: number = 0;
  @Input() restaurantid: number = 0;

  prebookingform = new FormGroup({
    restaurantid: new FormControl(0),
    fromdate: new FormControl(null, Validators.required),
    todate: new FormControl(null, Validators.required),
    cutoffdate: new FormControl(null, Validators.required),
    cutofftime: new FormControl(null, Validators.required),
     inactive:new FormControl(false),    
  });

  submitted: boolean = false;

  constructor(
    private activeModal: NgbActiveModal, 
    private appService: DhukanDataService,
    private loginService: LoginDataService, 
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    if (this.prebookingid > 0) {
      this.fnGetPreBooking();
    } else {
      this.prebookingform.patchValue({ restaurantid: this.restaurantid });
    }
  }

  fnGetPreBooking() {
    const data = { 
        'prebookingid': this.prebookingid, 
        'restaurantid': this.restaurantid 
    };
    this.appService.getRestaurantPrebooking(data).subscribe(
      (res) => {
        const result = res.json().result[0];
        this.prebookingform.patchValue({
          restaurantid: result.restaurantid,
          fromdate: result.fromdate,
          todate: result.todate,
          cutoffdate: result.cutoffdate,
          cutofftime: result.cutofftime,
           inactive: result.inactive == 1 ? true : false,  
        });
      },
      (err) => this.toastr.error('Error', err)
    );
  }

  fnSaveBtnClick() {
    this.submitted = true;
    if (this.prebookingform.valid) {
      const data = {
        'prebookingid': this.prebookingid,
        'restaurantid': this.restaurantid,
        'fromdate': this.prebookingform.get('fromdate').value,
        'todate': this.prebookingform.get('todate').value,
        'cutoffdate': this.prebookingform.get('cutoffdate').value,
        'cutofftime': this.prebookingform.get('cutofftime').value,
        'inactive': this.prebookingform.get('inactive').value,
        'createdby': this.loginService.fnGetModUserId(),
        'modifiedby': this.loginService.fnGetModUserId()
      };
      this.emitData.emit(data);
      this.activeModal.close(true);
    }
  }

  decline() {
    this.activeModal.dismiss();
  }
}